/**
 * Backside Engraving feature constants.
 */

/** Line item IDs allowed in the Backside Engraving modal. */
export const BACKSIDE_ENGRAVING_LINE_ITEM_IDS = [
  15376581427575,
  15376582672759,
  15376583786871,
  15376585097591,
]

/** Font options for the backside engraving form. */
export const BACKSIDE_FONT_OPTIONS = [
  { label: 'Modern', value: 'modern' },
  { label: 'Classic', value: 'classic' },
  { label: 'Italic', value: 'italic' },
]

/** Default SVG options when generating backside text. */
export const BACKSIDE_SVG_OPTIONS = { width: 256, fontSize: 24 }
